var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$marketing.showAdvertising
    ? _c(
        "article",
        [
          _c(
            "div",
            {
              class: [
                "wrap-ad wrap-monetization-ad card",
                { "with-close": _vm.withClose },
              ],
              style: [
                _vm.hasMargin
                  ? { "--card-margin-bottom": `${_vm.marginValue}` }
                  : { "--card-margin-bottom": "margin-bottom-0" },
              ],
            },
            [
              _c("div", { staticClass: "monetization-ad text-left size-sm" }, [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("Advertisement"),
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.placementClass }),
              ]),
              _vm._v(" "),
              _vm.withClose
                ? _c(
                    "button",
                    {
                      staticClass: "close",
                      staticStyle: {
                        "--with-close-close-color": "var(--fa-dk-violet)",
                      },
                      attrs: {
                        type: "button",
                        "aria-label": "Remove Ad",
                        "data-balloon-pos": "left",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.showRemoveAdsModal.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticStyle: { "--fa-width": "auto" },
                        attrs: { icon: _vm.$v7.duotone.faCircleXmark },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("owa-modal-upsell", {
            attrs: {
              "is-showing": _vm.isShowingRemoveAdsModal,
              "upsell-requirement": "Pro plan",
              "upsell-trigger": "Removing Advertisements",
              "upsell-trigger-icon-name": "faBillboard",
            },
            on: { "close-modal": _vm.hideRemoveAdsModal },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }